
import { PropType, defineComponent, nextTick } from "vue";
import SeCheckBox from "@/components/global/SeCheckBox.vue";
import Element from "@/model/Elements/Element";
import * as Lang from "@/i18n/lang";
import StoreElement from "@/model/Elements/StoreElement";
import { ModuleEnum } from "@/model/ModuleEnum";
import * as ImageUtils from "@/utils/ImageUtils";

export default defineComponent({
  props: {
    validElements: Array as PropType<Element[]>,
    selectedElements: Array as PropType<Element[]>,
    module: {
      default: ModuleEnum.Temperatures,
      required: true,
    },
    store: {
      type: Boolean,
      default: false,
    },
  },

  expose: ["automatic", "delivery", "getSelectedElements", "update"],
  data() {
    return {
      displayedElements: [] as Element[],
      automatic: false,
      delivery: false,
      Lang: Lang,
      ImageUtils: ImageUtils,
    };
  },

  methods: {
    onTabChange(index: number) {
      if (index == 0) {
        this.automatic = false;
        this.delivery = false;
      }
      if (index == 1) {
        this.automatic = false;
        this.delivery = true;
      }

      else if (index == 2) {
        this.automatic = true;
        this.delivery = false;
      }

    },
    displayAutomatic() {
      return this.store && this.module == ModuleEnum.Temperatures;
    },
    alreadySelected(item: Element): boolean {
      return this.selectedElements!.some(
        (element: Element) => element.getName() == item.getName()
      );
    },


    onSelectAllClicked() {
      var refs = <any>this.$refs;

      var flag = refs.selectAll.getValue();
      this.toggleSelectAll(!flag);
    },
    toggleSelectAll(flag: boolean) {
      var refs = <any>this.$refs;
      for (let i = 0; i < this.displayedElements.length; i++) {
        var ref = refs[i.toString()][0];

        ref.setValue(flag);
      }
    },

    toggleCheckBox(item: Element) {
      var index = this.displayedElements.indexOf(item);
      var refs = <any>this.$refs;

      if (refs[index] == undefined) {
        return;
      }

      var checkbox = refs[index.toString()][0];

      checkbox.setValue(!checkbox.getValue());
    },
    getSelectedElements() {
      let results: any = [];

      let refs = <any>this.$refs;

      for (let i = 0; i < this.displayedElements.length; i++) {
        let checkbox = refs[i.toString()][0];

        if (!checkbox) {
          console.warn("nothing here...");
          return;
        }
        var element = this.displayedElements[i];

        if (checkbox == refs.selectAll) {
          continue;
        }

        if (checkbox.getValue()) {
          results.push(element);
        }
      }


      return results;
    },

    update() {
      var refs = <any>this.$refs;

      nextTick(() => {

        console.log(this.automatic)

        if (this.automatic) {
          refs.tab.changeTabIndex(2);
          console.log(2)
        }
        else if (this.delivery) {
          refs.tab.changeTabIndex(1);
        }
        else {
          refs.tab.changeTabIndex(0);
        }


        this.onFiltersChange();

        console.log(this.selectedElements);

        nextTick(() => {
          for (let selectedElement of this.selectedElements) {
            var index = this.displayedElements.indexOf(selectedElement);
            var ref = this.$refs[index.toString()][0];
            ref.setValue(true);
          }
        });

      });
    },
    onFiltersChange() {
      var refs = <any>this.$refs;

      if (this.delivery) {
        this.displayedElements = this.validElements.filter((x) => (<StoreElement>x).getTemperatureDeliveryItem());
      }
      else {

        if (this.store && this.automatic) {
          var elements = this.getSelectedElements();

          this.displayedElements = this.validElements?.filter(
            (x) => (<StoreElement>x).probe_id != null
          )!;

          nextTick(() => {
            this.toggleSelectAll(false);
          });

        }
        else {

          this.displayedElements = this.validElements.filter(x => !x.getTemperatureDeliveryItem() && x.probe_id == null);
        }
      }


      refs.selectAll.setValue(false);
    },
  },
  watch: {
    validElements: {
      handler(val: Element[]) {
        this.displayedElements = val;
      },
    },

    delivery: {
      handler(val: boolean) {
        this.onFiltersChange();
      }
    },
    automatic: {
      handler(val: boolean) {
        this.onFiltersChange();
      },
    },
  },
});
